<tui-icon [tuiHintDirection]="direction" [tuiTooltip]="hintTemplate" (click)="onClick($event)" />

<ng-template #hintTemplate>
  <span>
    <ng-container *ngFor="let element of preparedHTMLStructure">
      <ng-container [ngSwitch]="element.type">
        <span *ngSwitchCase="'space'">{{ ' ' }}</span>

        <br *ngSwitchCase="'new-line'" />

        <span *ngSwitchCase="'text'">{{ element?.value ?? '' | translate }}</span>

        <tui-icon *ngSwitchCase="'svg'" [icon]="element.value ?? ''"></tui-icon>
      </ng-container>
    </ng-container>
  </span>
</ng-template>
